import { Flex } from "@chakra-ui/react";
import SanctionBanner from "@components/SanctionBanner";
import useSanction from "@hooks/useSanction";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import RestakeUnstake from "@components/V2/restake";

const StakeV2 = () => {
  const { isSanctioned } = useSanction();

  return (
    <Flex justifyContent="center" alignItems="center" flexDirection="column">
      {isSanctioned && (
        <Flex
          flexDir="column"
          gap="12px"
          mt={{ base: "16px", xl: "0px" }}
          w={{ base: "100%", md: "648px" }}
          mb="12px"
        >
          {<SanctionBanner />}
        </Flex>
      )}

      <Flex
        flexDir="column"
        gap="16px"
        w={"100%"}
        align={"center"}
        pointerEvents={isSanctioned ? "none" : "auto"}
        opacity={isSanctioned ? 0.5 : 1}
      >
        <RestakeUnstake />
      </Flex>
    </Flex>
  );
};

export default StakeV2;
